export default __webpack_public_path__ + "static/media/property_1_15.bf255dce.webp";